import { useEffect } from 'react';
import type { OfferDetailsResponse } from 'src/apis/super-bundle-service/types';
import type { SuperBundleServiceRequest } from 'src/apis/super-bundle-service/use-super-bundle-service-root';
import { useAxios } from 'src/hooks/use-axios';

export function useSuperBundleOfferDetails({
  superBundleServiceRoot,
}: {
  superBundleServiceRoot: SuperBundleServiceRequest;
}) {
  const superBundleOfferDetails = useAxios(
    (axios, baseConfig, { url }: { url: string }) => {
      return axios.request<OfferDetailsResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const url = superBundleServiceRoot.response?.data._links.getOffer?.href;
    if (!url) return;

    superBundleOfferDetails.execute({
      url,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [superBundleServiceRoot.response]);

  return superBundleOfferDetails;
}

export type SuperBundleOfferDetailsRequest = ReturnType<
  typeof useSuperBundleOfferDetails
>;
